document.addEventListener("DOMContentLoaded", function() {
  const now = new Date();
  const timestamp =
    now.getFullYear().toString() +
    String(now.getMonth() + 1).padStart(2, '0') +
    String(now.getDate()).padStart(2, '0') +
    String(now.getHours()).padStart(2, '0') +
    String(now.getMinutes()).padStart(2, '0') +
    String(now.getSeconds()).padStart(2, '0');

  // ---- imgタグ（class="no-cache"）----
  document.querySelectorAll("img.no-cache").forEach(img => {
    let src = img.getAttribute("src");
    if (!src) return;
    img.src = src + (src.includes("?") ? "&" : "?") + "t=" + timestamp;
  });

  // ---- CSSファイル（class="no-cache"）----
  document.querySelectorAll("link[rel='stylesheet'].no-cache").forEach(link => {
    let href = link.getAttribute("href");
    if (!href) return;
    link.href = href + (href.includes("?") ? "&" : "?") + "t=" + timestamp;
  });

  // ---- JSファイル（class="no-cache"）----
  document.querySelectorAll("script.no-cache[src]").forEach(script => {
    let src = script.getAttribute("src");
    if (!src) return;

    // 自分自身（cache-buster.js）は除外
    if (src.includes("cache-buster.js")) return;

    script.src = src + (src.includes("?") ? "&" : "?") + "t=" + timestamp;
  });
});
